import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const deletePromocodeApi = createAsyncThunk(
  "promocode/delete",
  async (promocodeId) => {
    try {
      const tokenData = await JSON.parse(localStorage.getItem("userData"))
        .token;
      return await fetch(
        `${process.env.REACT_APP_VERSEL_API}/api/user/promocode/deleteById/${promocodeId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        }
      ).then((res) => res.json());
    } catch (error) {
      swal("Error", error, "info");
      return error;
    }
  }
);

const DeletePromocodeSlicer = createSlice({
  name: "Delete Promocode",
  initialState: {
    loading: false,
    response: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(deletePromocodeApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletePromocodeApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(deletePromocodeApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "Data Deleted Successfully") {
        state.response = action.payload;
      } else {
        state.error = action.payload.message;
      }
    });
  },
});

export default DeletePromocodeSlicer.reducer;
